<ng-container *ngIf="!deleteAction">
  <ion-header class="ion-no-border">
    <ion-toolbar color="primary">
      <ion-title class="enhanced-title">
        <ion-icon name="medkit-outline" slot="start"></ion-icon>
        {{ creationDialog ? 'Nuova Operazione Chirurgica' : 'Modifica Operazione Chirurgica' }}
      </ion-title>
      <ion-buttons slot="end">
        <ion-button fill="clear" (click)="onClose()" class="close-button">
          <ion-icon slot="icon-only" [src]="'close' | getIcon"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <div class="enhanced-form">
      
      <!-- Sezione informazioni -->
      <div class="form-section info-section">
        <div class="info-card">
          <ion-icon name="information-circle-outline" class="info-icon"></ion-icon>
          <div class="info-text">
            <p>Cerca l'operazione chirurgica inserendo almeno 2 caratteri del codice ICD-9 e specifica la data dell'intervento</p>
          </div>
        </div>
      </div>

      <!-- Sezione contesto -->
      <div class="form-section" *ngIf="!selectedContext">
        <div class="section-header">
          <ion-icon name="layers-outline" class="section-icon"></ion-icon>
          <h3>Contesto Clinico</h3>
        </div>

        <ion-item class="enhanced-item" lines="none">
          <ion-label position="stacked" class="enhanced-label">Seleziona Contesto *</ion-label>
          <ion-select
            placeholder="Scegli il contesto appropriato"
            [(ngModel)]="selectedContext"
            [ngModelOptions]="{ standalone: true }"
            interface="popover"
            class="enhanced-select">
            <ion-select-option
              *ngFor="let ctxKey of patientContextsInfo | keyvalue"
              [value]="ctxKey.key">
              {{ ctxKey.value.label }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </div>
      
      <!-- Sezione ricerca -->
      <div class="form-section" *ngIf="!selectedIcd9">
        <div class="section-header">
          <ion-icon name="search-outline" class="section-icon"></ion-icon>
          <h3>Ricerca Operazione</h3>
        </div>

        <div class="search-container">
          <ion-item class="enhanced-item search-item" lines="none">
            <ion-label position="stacked" class="enhanced-label">Cerca per Codice ICD-9</ion-label>
            <ion-textarea
              placeholder="Cerca per codice o descrizione"
              [c3Autocomplete]="autocomplete"
              class="ion-text-uppercase c3-monospace enhanced-input"
              [(ngModel)]="codiceIcd9"
              #inputField
              (ngModelChange)="onQuickFilterChange($event)"
              [ngModelOptions]="{ standalone: true }"
              rows="1"
              auto-grow="true">
            </ion-textarea>
            <ion-spinner slot="end" color="primary" *ngIf="loading$ | async"></ion-spinner>
          </ion-item>

          <c3-autocomplete #autocomplete="c3Autocomplete" class="enhanced-autocomplete">
            <ng-template c3AutocompleteContent>
              <ion-list class="autocomplete-list">
                <ion-list-header *ngIf="listaCodiciIcd9?.length === 0" class="no-results">
                  <ion-icon name="search-outline"></ion-icon>
                  <ion-label>Nessuna operazione trovata</ion-label>
                </ion-list-header>
                
                <c3-option *ngFor="let code of listaCodiciIcd9" [value]="code">
                  <ion-item button class="operation-option">
                    <ion-avatar slot="start" class="code-avatar">
                      <ion-icon name="medkit"></ion-icon>
                    </ion-avatar>
                    
                    <ion-label class="code-info">
                      <h3>{{ code.description }}</h3>
                      <p class="code-number">ICD-9: {{ code.id }}</p>
                    </ion-label>
                    
                    <ion-icon name="arrow-forward-circle-outline" slot="end" color="primary"></ion-icon>
                  </ion-item>
                </c3-option>
              </ion-list>
            </ng-template>
          </c3-autocomplete>
        </div>
      </div>

      <!-- Sezione operazione selezionata -->
      <div class="form-section" *ngIf="selectedIcd9">
        <div class="section-header">
          <ion-icon [src]="'iv-bag' | getIcon" class="section-icon"></ion-icon>
          <h3>Operazione Selezionata</h3>
        </div>

        <div class="selected-card">
          <div class="selected-content">
            <ion-avatar class="selected-avatar">
              <ion-icon name="medkit"></ion-icon>
            </ion-avatar>
            
            <div class="selected-info">
              <h3>{{ selectedIcd9?.description }}</h3>
              <p class="selected-code">ICD-9: {{ selectedIcd9?.id }}</p>
            </div>
          </div>

          <ion-button 
            fill="outline" 
            color="primary" 
            size="small" 
            (click)="onIcd9Selected(null)"
            class="change-button">
            <ion-icon name="refresh-outline" slot="start"></ion-icon>
            <span>Cambia Operazione</span>
          </ion-button>
        </div>

        <!-- Data operazione -->
        <div class="date-section">
          <div class="section-header">
            <ion-icon name="calendar-outline" class="section-icon"></ion-icon>
            <h3>Data Intervento</h3>
          </div>

          <ion-item class="enhanced-item date-item" lines="none">
            <ion-label position="stacked" class="enhanced-label">Data Operazione *</ion-label>
            <ion-input
              type="date"
              [(ngModel)]="selectedOperationDate"
              [ngModelOptions]="{ standalone: true }"
              class="enhanced-date-input">
            </ion-input>
          </ion-item>
        </div>
      </div>

    </div>
  </ion-content>

  <ion-footer class="enhanced-footer">
    <div class="footer-actions">
      
      <ion-button 
        fill="solid"
        color="primary" 
        [disabled]="(loading$ | async) || !canSubmit" 
        (click)="onSubmit()"
        class="save-button">
        <ion-spinner *ngIf="loading$ | async" slot="start"></ion-spinner>
        <ion-icon *ngIf="!(loading$ | async)" name="save-outline" slot="start"></ion-icon>
        Salva Operazione
      </ion-button>
    </div>
  </ion-footer>
</ng-container>

<ng-container *ngIf="deleteAction">
  <ion-header class="ion-no-border">
    <ion-toolbar color="danger">
      <ion-title>
        <ion-icon name="trash-outline" slot="start"></ion-icon>
        Elimina Operazione
      </ion-title>
      <ion-buttons slot="end">
        <ion-button fill="clear" (click)="onClose()" class="close-button">
          <ion-icon slot="icon-only" [src]="'close' | getIcon"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content class="enhanced-content">
    <div class="enhanced-form">
      <div class="form-section delete-section">
        <div class="delete-warning">
          <ion-icon name="warning-outline" class="warning-icon"></ion-icon>
          <div class="warning-content">
            <h3>Conferma Eliminazione</h3>
            <p>Sei sicuro di voler eliminare definitivamente questa operazione chirurgica?</p>
          </div>
        </div>

        <div>
          <div>
            <h4>{{ selectedIcd9?.description }}</h4>
            <p class="delete-code">ICD-9: {{ selectedIcd9?.id }}</p>
          </div>
        </div>

      
      </div>
    </div>
  </ion-content>

  <ion-footer class="enhanced-footer delete-footer">
    <div class="footer-actions">
      <ion-button 
        fill="solid"
        color="danger" 
        [disabled]="(loading$ | async) || !canSubmit" 
        (click)="deleteOperation()"
        class="delete-button">
        <ion-spinner *ngIf="loading$ | async" slot="start" color="light"></ion-spinner>
        <ion-icon *ngIf="!(loading$ | async)" name="trash-outline" slot="start"></ion-icon>
        Elimina Operazione
      </ion-button>
    </div>
  </ion-footer>
</ng-container>